import React, { createRef } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { GetCorService, genURL, gengetURLTEST } from "./../_getjson.js";
import axios from "axios";
import { Nav, NavItem } from "react-bootstrap";
import { AlertPopup } from "./AlertPopup";
import SelectDatas from "./../PopUp/SelectData";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import Snackbar from "./../Components/Snackbar/Snackbar";

import { number } from "prop-types";

require("./../_css/PopUpOther.css");
const mystyle = {
  paddingBottom: "0px",
  // paddingLeft:'0px'
};
export default class SaveMoney extends React.Component {
  constructor(props) {
    super(props);
    this.AmountPayable = React.createRef();
    this.Balance = React.createRef();
    this.CashReceipt1 = React.createRef();
    this.Bankamount = React.createRef();
    this.Bankexpend = React.createRef();
    this.Remark = React.createRef();
    this.CustomerName = React.createRef();
    this.Chequeno = React.createRef();
    this.Chqamount = React.createRef();
    this.Chqpay = React.createRef();
    this.ChqRemark = React.createRef();
    this.Creditno = React.createRef();
    this.Creditpay = React.createRef();
    this.Charge = React.createRef();
    this.Chargeamount = React.createRef();
    this.Creditamount = React.createRef();
    this.Confirmno = React.createRef();
    this.CreditRemark = React.createRef();
    this.sumOtherincome = React.createRef(0.0);
    this.sumExpenses = React.createRef(0.0);
    this.state = {
      activeKey: "0",
      Pform: this.props.pms.split("|")[0],
      PCash: this.props.pms.split("|")[1],
      PMtransfer: this.props.pms.split("|")[2],
      Pcheck: this.props.pms.split("|")[3],
      PCCredit: this.props.pms.split("|")[4],
      PIncome: this.props.pms.split("|")[5],
      PExpens: this.props.pms.split("|")[6],
      Chargepay: "0",
      Bookno: "0",
      recchq: [],
      Credit: [],
      Otherincome: [],
      expenses: [],
      swithholdingdevalue: 0,
      depositpaymentvalue: 0,
      submitbuttondisabled: false,
    };
  }
  async componentDidMount() {
    let recheckeddatalength = 0;
    try {
      recheckeddatalength = this.props.recheckeddata.length;
    } catch (error) {
      console.log("error", error);
    }
    let sumAmountPayable =
      Number(this.props.AmountPayable) -
      Number(
        typeof this.props.depositpayment !== "undefined" &&
          recheckeddatalength > 0
          ? this.props.depositpayment
          : 0
      );
    this.AmountPayable.current.value = await parseFloat(
      sumAmountPayable
    ).toFixed(2);
    this.setState({
      swithholdingdevalue:
        typeof this.props.withholdingdevalue !== "undefined"
          ? this.props.withholdingdevalue
          : 0,
    });
    try {
      if (this.props.recheckeddata.length > 0) {
        console.log("RecheckedDocno", this.props.recheckeddata[0].DOCNO);
        this.RecheckedData(this.props.recheckeddata);
        this.setState({
          depositpaymentvalue:
            typeof this.props.depositpayment !== "undefined"
              ? this.props.depositpayment
              : 0,
        });
      } else {
        // this.Balance.current.value = await parseFloat(Number(this.props.AmountPayable) - Number(this.state.swithholdingdevalue)).toFixed(2);
        // setdefult เงินสด/เงินโอน
        if (this.props.DataSavemoney) {
          this.CashReceipt1.current.value = await Number(
            this.props.DataSavemoney.CashReceipt
          );
          this.CashReceipt1.current.focus();
          this.CashReceipt1.current.select();
          this.setState({ Bookno: this.props.DataSavemoney.Bookno });
          this.Bankamount.current.value = await Number(
            this.props.DataSavemoney.Bankamount
          ).toFixed(2);
          this.Bankexpend.current.value = await Number(
            this.props.DataSavemoney.Bankexpend
          ).toFixed(2);
          this.Remark.current.value = this.props.DataSavemoney.Remark;
          // this.Calculate();
          // setdefult เช็ครับ/ตั๋วเงิน
          if (this.props.DataSavemoney.recchq) {
            this.setState({ recchq: await this.props.DataSavemoney.recchq });
            // this.Calculate();
            let row = this.props.DataSavemoney.recchq[0];
            this.Chequeno.current.value = row.Chequeno;
            this.setState({ s_Bankcode: row.Bankcode });
            this.setState({ s_Bankbranch: row.Bankbranch });
            this.setState({ s_Chqdate: row.Chqdate });
            this.Chqamount.current.value = row.Chqamount;
            this.Chqpay.current.value = row.Chqpay;
            this.ChqRemark.current.value = row.Remark;
          } else {
            this.setRowrecchq(10);
            this.Chqamount.current.value = (0).toFixed(2);
            this.Chqpay.current.value = (0).toFixed(2);
          }
          // setdefult บัตรเครดิต
          if (this.props.DataSavemoney.Credit) {
            this.setState({ Credit: await this.props.DataSavemoney.Credit });
            // this.Calculate();
            let row = this.props.DataSavemoney.Credit[0];
            this.Creditno.current.value = row.Creditno;
            this.setState({ Chargepay: row.Chargepay });
            this.setState({ Credittype: row.Credittype });
            this.Creditpay.current.value = row.Creditpay;
            this.Charge.current.value = row.Charge;
            this.Chargeamount.current.value = row.Chargeamount;
            this.Creditamount.current.value = row.Creditamount;
            this.Confirmno.current.value = row.Confirmno;
            this.CreditRemark.current.value = row.Remark;
          } else {
            this.setRowCredit(10);
            this.Creditpay.current.value = (0).toFixed(2);
            this.Creditamount.current.value = (0).toFixed(2);
            this.Charge.current.value = (0).toFixed(2);
            this.Chargeamount.current.value = (0).toFixed(2);
          }
          // setdefult รายได้อื่นๆ
          if (this.props.DataSavemoney.tbincome) {
            this.setState({
              Otherincome: await this.props.DataSavemoney.tbincome,
            });
            // this.Calculate();
          } else {
            this.setRowIncome(10);
            this.sumOtherincome.current.value = (0).toFixed(2);
          }
          // setdefult ค่าใช้จ่ายอื่นๆ
          if (this.props.DataSavemoney.tbexpenses) {
            this.setState({
              expenses: await this.props.DataSavemoney.tbexpenses,
            });
            // this.Calculate();
          } else {
            this.setRowexpenses(10);
            this.sumExpenses.current.value = (0).toFixed(2);
          }
        } else {
          // this.props.DataSavemoney เท่ากับค่าว่าง
          this.CashReceipt1.current.value = 0;
          this.CashReceipt1.current.focus();
          this.CashReceipt1.current.select();
          this.Bankamount.current.value = (0).toFixed(2);
          this.Bankexpend.current.value = (0).toFixed(2);
          this.setRowrecchq(10);
          this.Chqamount.current.value = (0).toFixed(2);
          this.Chqpay.current.value = (0).toFixed(2);
          this.setRowCredit(10);
          this.Creditpay.current.value = (0).toFixed(2);
          this.Creditamount.current.value = (0).toFixed(2);
          this.Charge.current.value = (0).toFixed(2);
          this.Chargeamount.current.value = (0).toFixed(2);
          this.setRowIncome(10);
          this.sumOtherincome.current.value = (0).toFixed(2);
          this.setRowexpenses(10);
          this.sumExpenses.current.value = (0).toFixed(2);
        }
      }
    } catch (error) {}

    await this.Calculate();
  }

  //---------------create 05/01/23 ----------------------------------
  RecheckedData = async (data) => {
    this.setState({ submitbuttondisabled: true });
    //console.log("RecheckedData", data);
    this.CashReceipt1.current.value = await data[0].CASHAMOUNT; //cashbalance
    // this.advanceamount.current.value = await data[0].ADVANCEPAY
    // this.checkpettycash(data[0].PETTYCASHCODE)
    // this.pettycashvalue.current.value = await data[0].PETTYCASH
    await this.setState({ Bookno: data[0].BOOKNO });
    this.Bankamount.current.value = data[0].BANKAMOUNT;
    this.Bankexpend.current.value = data[0].BANKEXPEND;
    this.Remark.current.value = data[0].BOOKDESC;
    // load recchq
    let url =
      "CSRECCHQ/Search?Tablename=" +
      this.props.from +
      "&Docno=" +
      data[0].DOCNO;
    console.log("CSRECCHQ", genURL(url));
    let rscchqData = await axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        return res.data;
      });
    await console.log("rscchqData", rscchqData);
    let itemrscchq = [];
    if (rscchqData.length > 0) {
      for (let index = 0; index < rscchqData.length; index++) {
        // const element = array[index];
        //  console.log("recchq", rscchqData[index].CHEQUENO);
        itemrscchq[index] = {
          C0: index + 1,
          Chequeno: rscchqData[index].CHEQUENO,
          Bankcode: rscchqData[index].BANKCODE,
          Bankbranch: rscchqData[index].BANKBRANCH,
          Chqdate: rscchqData[index].DOCDATE,
          Chqamount: rscchqData[index].CHQAMOUNT,
          Chqpay: rscchqData[index].CHQPAY,
          Remark: rscchqData[index].REMARK,
        };
      }
    }
    // await console.log("recchq", itemrscchq)
    await this.setState({ recchq: itemrscchq });
    await console.log("this.state.recchq", this.state.recchq);

    // load reccredit
    let urlreccredit =
      "CSRECCREDIT/Search?Tablename=" +
      this.props.from +
      "&Docno=" +
      data[0].DOCNO;
    // console.log("genURL(url)", genURL(url))
    let reccreditData = await axios
      .get(genURL(urlreccredit), { timeout: 3600 })
      .then((res) => {
        return res.data;
      });
    await console.log("CSRECCREDIT", reccreditData);
    let itemreccredit = [];
    if (reccreditData.length > 0) {
      for (let index = 0; index < reccreditData.length; index++) {
        // const element = array[index];
        itemreccredit[index] = {
          C0: index + 1,
          Creditno: reccreditData[index].CREDITNO,
          Credittype: reccreditData[index].CREDITTYPE,
          Creditpay: reccreditData[index].CREDITPAY,
          Charge: reccreditData[index].CHARGE,
          Chargeamount: reccreditData[index].CHARGEAMOUNT,
          Creditamount: reccreditData[index].CREDITAMOUNT,
          Confirmno: reccreditData[index].CONFIRMNO,
          Remark: reccreditData[index].REMARK,
          Chargepay: reccreditData[index].CHARGEPAY,
        };
      }
    }
    // await console.log("recchq", itemreccredit)
    await this.setState({ Credit: itemreccredit });
    // end Credit start CSRECINCOME

    let urlCSINCOME =
      "CSRECINCOME/Search?Tablename=" +
      this.props.from +
      "&Docno=" +
      data[0].DOCNO;
    console.log("genURL(url)", genURL(urlCSINCOME));
    let csrecincomData = await axios
      .get(genURL(urlCSINCOME), { timeout: 3600 })
      .then((res) => {
        return res.data;
      });
    await console.log("csrecincomData", csrecincomData);
    let itemOtherincome = [];
    let Incomename = "";
    if (csrecincomData.length > 0) {
      for (let index = 0; index < csrecincomData.length; index++) {
        await this.loadIncomename(csrecincomData[index].INCOME).then(
          (value) => {
            Incomename = value;
          }
        ),
          (itemOtherincome[index] = {
            C0: index + 1,
            BTN: "delect",
            Incomecode: csrecincomData[index].INCOME,
            Incomename: Incomename,
            Incomeremark: csrecincomData[index].REMARK,
            Incomeamount: csrecincomData[index].AMOUNT,
          });
      }
    }
    await this.setState({ Otherincome: itemOtherincome });

    // end recincome start Expense
    let urlCSRECEXPENSE =
      "CSRECEXPENSE/Search?Tablename=" +
      this.props.from +
      "&Docno=" +
      data[0].DOCNO;
    console.log("genURL(url)", genURL(urlCSRECEXPENSE));
    let csreexpensesData = await axios
      .get(genURL(urlCSRECEXPENSE), { timeout: 3600 })
      .then((res) => {
        return res.data;
      });
    await console.log("csreexpensesdata", csreexpensesData);
    let Expensesdata = [];
    let expensesname = "";
    if (csreexpensesData.length) {
      for (var i = 0; i < csreexpensesData.length; i++) {
        await this.loadexpensesname(csreexpensesData[i].EXPENSE).then(
          (value) => {
            expensesname = value;
          }
        ),
          (Expensesdata[i] = {
            C0: i + 1,
            Expensescode: csreexpensesData[i].EXPENSE, //0
            Expensesname: expensesname,
            Expensesamount: csreexpensesData[i].AMOUNT, //1
            Expensesremark: csreexpensesData[i].REMARK, //2
            BTN: "delect",
          });
      }
      await this.setState({ expenses: Expensesdata });
    }

    await this.Calculate();
  };

  // load Income name for recheck
  loadIncomename = async (datasearch) => {
    let url = "CSINCOME/GETCODESCSINCOME?Codes=" + datasearch;

    var data_ = [];
    console.log(genURL(url));
    let icomname = await axios
      .get(genURL(url), { timeout: 60000 })
      .then((res) => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            return res.data[i].MYNAMETH;
          }
        }
      });
    await console.log("icomname", icomname);
    return icomname;
  };

  loadexpensesname = async (datasearch) => {
    let url = "CSEXPENSE/GETCODES?Codes=" + datasearch;

    var data_ = [];
    console.log(genURL(url));
    let expensesname = await axios
      .get(genURL(url), { timeout: 60000 })
      .then((res) => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            return res.data[i].MYNAMETH;
          }
        }
      });
    await console.log("expensesname", expensesname);
    return expensesname;
  };
  setRowrecchq = (count) => {
    var data = [];
    for (let i = 0; i <= count - 1; i++) {
      data[i] = {
        C0: i + 1,
        Chequeno: "",
        Bankcode: "",
        Bankbranch: "",
        Chqdate: "",
        Chqamount: "",
        Chqpay: "",
        Remark: "",
      };
    }
    this.setState({ recchq: data });
  };
  setRowCredit = (count) => {
    var data = [];
    for (let i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ Credit: data });
    this.setState({ charge: true });
  };
  setRowIncome = (count) => {
    var data = [];
    for (let i = 0; i <= count - 1; i++) {
      data[i] = {
        C0: i + 1,
        Incomecode: "",
        BTN: 1,
        Incomename: "",
        Incomeremark: "",
        Incomeamount: "",
      };
    }
    this.setState({ Otherincome: data });
  };
  setRowexpenses = (count) => {
    var data = [];
    for (let i = 0; i <= count - 1; i++) {
      data[i] = {
        C0: i + 1,
        Expensescode: "",
        BTN: 1,
        Expensesname: "",
        Expensesremark: "",
        Expensesamount: "",
      };
    }
    this.setState({ expenses: data });
  };
  CashReceipt = (e) => {
    this.Calculate();
  };
  Calculate = async () => {
    let recchq = 0.0;
    if (this.state.recchq.length > 0) {
      for (let index = 0; index < this.state.recchq.length; index++) {
        if (this.state.recchq[index].Chequeno) {
          recchq += parseFloat(this.state.recchq[index].Chqpay);
        }
      }
    }
    let Creditamount = 0.0;
    let Chargeamount = 0.0;
    if (this.state.Credit.length > 0) {
      for (let index = 0; index < this.state.Credit.length; index++) {
        if (this.state.Credit[index].Creditno) {
          Creditamount += parseFloat(this.state.Credit[index].Creditpay);
          // if (this.state.Credit[index].Chargepay + "" === "2") {
          Chargeamount += parseFloat(this.state.Credit[index].Chargeamount);
          // }
        }
      }
    }
    if (this.state.Otherincome.length > 0) {
      let OtherBat = 0;
      for (var i = 0; i < this.state.Otherincome.length; i++) {
        if (this.state.Otherincome[i].Incomeamount) {
          OtherBat += parseFloat(this.state.Otherincome[i].Incomeamount);
        }
      }
      this.sumOtherincome.current.value = OtherBat.toFixed(2);
    }

    if (this.state.expenses.length > 0) {
      let Expenses = 0;
      for (var i = 0; i < this.state.expenses.length; i++) {
        if (this.state.expenses[i].Expensesamount) {
          Expenses += parseFloat(this.state.expenses[i].Expensesamount);
        }
      }
      console.log(this.state.expenses);
      this.sumExpenses.current.value = Expenses.toFixed(2);
    }

    try {
      let BalanceIn =
        (await (Number(this.props.AmountPayable) -
          Number(this.state.swithholdingdevalue) +
          Number(this.sumOtherincome.current.value))) -
        (Number(this.CashReceipt1.current.value) +
          Number(this.Bankamount.current.value) +
          Number(this.sumExpenses.current.value) +
          Number(this.Bankexpend.current.value) +
          Number(recchq) +
          Number(Creditamount) +
          Number(this.state.depositpaymentvalue));
      this.Balance.current.value = await BalanceIn.toFixed(2);
    } catch (error) {}
  };
  OnSave = async (status) => {
    //ยอดเงินรวมที่ต้องชำระ
    var AmountPayable = this.AmountPayable.current.value;
    //เงินสด
    var CashReceipt1 = this.CashReceipt1.current.value;
    //โอน
    var Booknoval = this.state.Bookno;
    var Bankamountval = this.Bankamount.current.value;
    var Bankexpendval = this.Bankexpend.current.value;
    var Remarkval = this.Remark.current.value;

    var moneytransfer =
      Booknoval + "|" + Bankamountval + "|" + Bankexpendval + "|" + Remarkval;
    var tbrecchq = [];
    let recchq = [];
    var recchqsum = 0;
    var arrayrecchq = this.state.recchq;

    var CSRECCHQ = [];
    var CSRECCHQData = [];
    for (let i = 0; i < arrayrecchq.length; i++) {
      if (
        arrayrecchq[i].Chequeno !== undefined &&
        arrayrecchq[i].Chequeno !== ""
      ) {
        tbrecchq[i] =
          arrayrecchq[i].Chequeno +
          "|" + //0
          arrayrecchq[i].Bankcode +
          "|" + //1
          (arrayrecchq[i].Bankbranch ? arrayrecchq[i].Bankbranch : "") +
          "|" + //2
          arrayrecchq[i].Chqdate +
          "|" + //3
          arrayrecchq[i].Chqamount +
          "|" + //4
          arrayrecchq[i].Bankcode +
          "|" + //5
          arrayrecchq[i].Remark; //6
        recchq.push(tbrecchq[i]);
        recchqsum += parseFloat(arrayrecchq[i].C2);

        CSRECCHQData[i] = {
          Chequeno: arrayrecchq[i].Chequeno, //0
          Bankcode: arrayrecchq[i].Bankcode, //1
          Bankbranch: arrayrecchq[i].Bankbranch, //2
          Chqdate: arrayrecchq[i].Chqdate, //3
          Chqamount: arrayrecchq[i].Chqamount, //4
          Chqpay: arrayrecchq[i].Chqpay, //5
          Remark: arrayrecchq[i].Remark, //6
        };
        CSRECCHQ.push(CSRECCHQData[i]);
      }
    }
    var Creditsum = 0;
    var CHARGEAMOUNT = 0;
    var CHARGEPAY1 = 0;
    var CHARGEPAY2 = 0;
    var tbCredit = [];
    var Credit = [];
    var arrayCredit = this.state.Credit;
    var CSRECCREDIT = [];
    var CSRECCREDITData = [];

    for (let i = 0; i < arrayCredit.length; i++) {
      if (arrayCredit[i].Creditno) {
        tbCredit[i] =
          arrayCredit[i].Creditno +
          "|" + //0
          arrayCredit[i].Chargepay +
          "|" + //1
          arrayCredit[i].Credittype +
          "|" + //2
          arrayCredit[i].Creditpay +
          "|" + //3
          arrayCredit[i].Charge +
          "|" + //4
          arrayCredit[i].Chargeamount +
          "|" + //5
          arrayCredit[i].Creditamount +
          "|" + //6
          arrayCredit[i].Confirmno +
          "|" + //7
          arrayCredit[i].Remark; //8
        Credit.push(tbCredit[i]);
        Creditsum += Number(arrayCredit[i].C2);
        CHARGEAMOUNT += Number(arrayCredit[i].Chargeamount);
        if (arrayCredit[i].Chargepay === "1") {
          CHARGEPAY1 += parseFloat(arrayCredit[i].Chargeamount);
        }
        if (arrayCredit[i].Chargepay === "2") {
          CHARGEPAY2 += parseFloat(arrayCredit[i].Chargeamount);
        }

        // new JSON style
        CSRECCREDITData[i] = {
          Creditno: arrayCredit[i].Creditno, //0
          Credittype: arrayCredit[i].Credittype, //1
          Creditpay: arrayCredit[i].Creditpay, //2
          Charge: arrayCredit[i].Charge, //3
          Chargeamount: arrayCredit[i].Chargeamount, //4
          Creditamount: arrayCredit[i].Creditamount, //5
          Confirmno: arrayCredit[i].Confirmno, //6
          Remark: arrayCredit[i].Remark,
          Chargepay: arrayCredit[i].Chargepay,
        };
        CSRECCREDIT.push(CSRECCREDITData[i]);
      }
    }
    var tbOtherincome = [];
    var income = [];
    var arrayOtherincome = this.state.Otherincome;
    // new JSON style
    var CSRECINCOMEData = [];
    var CSRECINCOME = [];
    for (var i = 0; i < arrayOtherincome.length; i++) {
      if (arrayOtherincome[i].Incomecode) {
        let Incomeremark = !arrayOtherincome[i].Incomeremark
          ? ""
          : arrayOtherincome[i].Incomeremark;
        tbOtherincome[i] =
          arrayOtherincome[i].Incomecode +
          "|" + //0
          arrayOtherincome[i].Incomename +
          "|" + //1
          Incomeremark +
          "|" + //2
          arrayOtherincome[i].Incomeamount; //3
        income.push(tbOtherincome[i]);

        // new JSON style
        CSRECINCOMEData[i] = {
          Income: arrayOtherincome[i].Incomecode, //0
          Amount: arrayOtherincome[i].Incomeamount, //1
          Remark: Incomeremark, //2
        };
        CSRECINCOME.push(CSRECINCOMEData[i]);
      }
    }

    var tbExpenses = [];
    var Expenses = [];
    var arrayexpenses = this.state.expenses;

    let CSRECEXPENSE = [];
    let CSRECEXPENSEData = [];

    for (var i = 0; i < arrayexpenses.length; i++) {
      if (arrayexpenses[i].Expensescode) {
        let Expensesremark = !arrayexpenses[i].Expensesremark
          ? ""
          : arrayexpenses[i].Expensesremark;
        tbExpenses[i] =
          arrayexpenses[i].Expensescode +
          "|" + //0
          arrayexpenses[i].Expensesname +
          "|" + //1
          Expensesremark +
          "|" + //2
          arrayexpenses[i].Expensesamount; //3
        Expenses.push(tbExpenses[i]);

        // new JSON style
        CSRECEXPENSEData[i] = {
          Expense: arrayexpenses[i].Expensescode, //0
          Amount: arrayexpenses[i].Expensesamount, //1
          Remark: Expensesremark, //2
        };
        CSRECEXPENSE.push(CSRECEXPENSEData[i]);
      }
    }
    var incomesum = 0;
    if (this.sumOtherincome.current.value !== "0.00") {
      incomesum = this.sumOtherincome.current.value;
    }
    var Expensessum = 0;
    if (this.sumExpenses.current.value !== "0.00") {
      Expensessum = this.sumExpenses.current.value;
    }
    if (status === "accress") {
      if (Number(this.Balance.current.value) < 0) {
        console.log("กรุณากรอกยอดเงิน ", this.Balance.current.value);
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกยอดเงิน" });
        return;
      }
      if (Number(this.Balance.current.value) > 0) {
        console.log("กรุณากรอกยอดเงิน", this.Balance.current.value);
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกยอดเงิน" });
        return;
      }

      this.props.get_PopUpSaveMoney(
        status,
        AmountPayable,
        CashReceipt1,
        moneytransfer,
        recchq,
        recchqsum,
        Credit,
        Creditsum,
        income,
        incomesum,
        Expenses,
        Expensessum,
        CHARGEAMOUNT,
        CHARGEPAY1,
        CHARGEPAY2,
        "",
        "",
        "",
        "",
        //เพิ่มเติม  new JSON style
        CSRECCHQ,
        CSRECCREDIT,
        CSRECEXPENSE,
        CSRECINCOME
      );
      this.props.closePopup();
    }
    if (status === "close") {
      let tbrecchq = await (recchqsum > 0 ? this.state.recchq : "");
      let tbCredit = await (Creditsum > 0 ? this.state.Credit : "");
      let tbOtherincome = await (incomesum > 0 ? this.state.Otherincome : "");
      let tbexpenses = await (Expensessum > 0 ? this.state.expenses : "");
      this.props.get_PopUpSaveMoney(
        status,
        AmountPayable,
        CashReceipt1,
        moneytransfer,
        recchq,
        recchqsum,
        Credit,
        Creditsum,
        income,
        incomesum,
        Expenses,
        Expensessum,
        CHARGEAMOUNT,
        CHARGEPAY1,
        CHARGEPAY2,
        tbrecchq,
        tbCredit,
        tbOtherincome,
        tbexpenses,
        //เพิ่มเติม  new JSON style
        CSRECCHQ,
        CSRECCREDIT,
        CSRECEXPENSE,
        CSRECINCOME
      );
      this.props.closePopup();
    }
  };
  /*------------------------------------------------------------- AC3 -------------------------------------------------------------------*/
  OtherincomeBTN(cell, row, enumObject, rowIndex) {
    var btn = row.BTN;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            align="center"
            onClick={this.Switch_PopupOtherBat.bind(null)}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case "delect":
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            align="center"
            onClick={this.delectROW.bind(null, rowIndex)}
          >
            <i className="far fa-trash-alt" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }

  delectROW = (row) => {
    var ROWDATA = this.state.Otherincome;
    ROWDATA[row] = {
      C0: row + 1,
      BTN: 1,
    };
    var j = 0;
    for (var i = 0; i < ROWDATA.length; i++) {
      if (ROWDATA[i].Incomecode) {
        ROWDATA[j] = ROWDATA[i];
        ROWDATA[j].C0 = j + 1;
        j++;
      }
    }
    for (var i = j; i < 10; i++) {
      ROWDATA[i] = { C0: i + 1, BTN: 1 };
    }
    this.setState({ Otherincome: ROWDATA });
    setTimeout(() => {
      this.Calculate();
    }, 50);
  };
  onAfterSaveCellOtherincomecal = (row, cellName, cellValue) => {
    this.Calculate();
  };
  /*------------------------------------------------------------- AC4 -------------------------------------------------------------------*/
  expensesBTN(cell, row, enumObject, rowIndex) {
    var btn = row.BTN;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            align="center"
            onClick={this.Switch_PopupExpenses.bind(null)}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case "delect":
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            align="center"
            onClick={this.expensesDelectROW.bind(null, rowIndex)}
          >
            <i className="far fa-trash-alt" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }

  expensesDelectROW = (row) => {
    var ROWDATA = this.state.expenses;
    ROWDATA[row] = {
      C0: row + 1,
      BTN: 1,
    };
    var j = 0;
    for (var i = 0; i < ROWDATA.length; i++) {
      if (ROWDATA[i].Expensescode) {
        ROWDATA[j] = ROWDATA[i];
        ROWDATA[j].C0 = j + 1;
        j++;
      }
    }
    for (var i = j; i < 10; i++) {
      ROWDATA[i] = { C0: i + 1, BTN: 1 };
    }
    this.setState({ expenses: ROWDATA });
    this.Calculate();
  };

  onAfterSaveCellAC4cal = (row, cellName, cellValue) => {
    this.Calculate();
  };

  calCredit = () => {
    console.log("Chargepay", this.state.Chargepay);
    // this.Charge.current.value = parseFloat(this.Chargeamount.current.value * 100).toFixed(2)
    // this.Chargeamount.current.value = parseFloat(this.Creditpay.current.value / 100 * this.Charge.current.value).toFixed(2)
    if (this.state.Chargepay === "1" || this.state.Chargepay === "2") {
      this.Creditamount.current.value = parseFloat(
        Number(this.Creditpay.current.value) +
          Number(this.Chargeamount.current.value)
      ).toFixed(2);
    } else if (this.state.Chargepay === "0") {
      this.Creditamount.current.value = this.Creditpay.current.value;
    }
  };
  SelectSetData = async (data1, data2, data3) => {
    // console.log(data1, data2, data3);
    switch (data1) {
      case "Credittype":
        if (data3) {
          await this.setState({ Credittype: data2 });
          // this.setState({ Credit3: data3 })
        }
        break;
      case "BOOKNO":
        console.log("BOOKNO", data2);
        this.setState({ Bookno: data2 });
        if (data2 === "0") {
          this.Bankamount.current.value = "0.00";
          this.Bankexpend.current.value = "0.00";
          this.Remark.current.value = "";
        }
        this.CashReceipt();

        break;
      case "Csbank":
        if (data3 !== undefined) {
          this.setState({ s_Bankcode: data2 });
          this.setState({ s_Bankname: data3 });
        }
        break;
      case "Bankbranch":
        console.log(data2);
        this.setState({ s_Bankbranch: data2 });
        break;
      case "Calendar":
        // if (this.CustomerNamedate.current.value === "") {
        //     this.CustomerNamedate.current.value = data2
        // }
        console.log(data2);
        this.setState({ s_Chqdate: data2 });
        break;
      case "Fee":
        if (data2 === "0") {
          await this.setState({ charge: true });
        } else {
          await this.setState({ charge: false });
        }
        await this.setState({ Chargepay: data2 });
        await this.calCredit();
        break;

      default:
        break;
    }
  };
  Newrecchq = () => {
    this.Chequeno.current.value = "";
    this.state.s_Bankname = "";
    this.setState({ s_Bankcode: "" });
    this.setState({ s_Bankbranch: "" });
    // this.state.Chqdate = this.props.date
    this.setState({ s_Chqdate: "" });
    this.Chqamount.current.value = (0).toFixed(2);
    this.Chqpay.current.value = (0).toFixed(2);
    this.ChqRemark.current.value = "";
  };
  NewCredit = () => {
    this.Creditno.current.value = "";
    this.setState({ Chargepay: "" });
    this.setState({ Credittype: "" });
    this.Creditpay.current.value = (0).toFixed(2);
    this.Charge.current.value = (0).toFixed(2);
    this.Chargeamount.current.value = (0).toFixed(2);
    this.Creditamount.current.value = (0).toFixed(2);
    this.Confirmno.current.value = "";
    this.CreditRemark.current.value = "";
  };
  Delrecchq = () => {
    var arrayrecchq = this.state.recchq;
    var id = this.state.id;
    if (this.Chequeno.current.value !== "" && id !== undefined) {
      this.Chequeno.current.value = "";
      this.setState({ s_Bankname: "" });
      this.setState({ s_Bankcode: "" });
      this.setState({ s_Bankbranch: "" });
      this.setState({ s_Chqdate: "" });
      this.Chqamount.current.value = (0).toFixed(2);
      this.Chqpay.current.value = (0).toFixed(2);
      this.ChqRemark.current.value = "";

      // arrayrecchq[i].Chequeno + "|" +//0
      //     arrayrecchq[i].Bankcode + "|" +//1
      //     (arrayrecchq[i].Bankbranch ? arrayrecchq[i].Bankbranch : "") + "|" +//2
      //     arrayrecchq[i].Chqdate + "|" +//3
      //     arrayrecchq[i].Chqamount + "|" +//4
      //     arrayrecchq[i].Bankcode + "|" +//5
      //     arrayrecchq[i].Remark
      arrayrecchq[id].C0 = "";
      arrayrecchq[id].Chequeno = "";
      arrayrecchq[id].Bankcode = "";
      arrayrecchq[id].Bankbranch = "";
      arrayrecchq[id].Chqdate = "";
      arrayrecchq[id].Chqamount = "";
      arrayrecchq[id].Bankcode = "";
      arrayrecchq[id].Remark = "";
      var NewCol = [];
      var j = 0;
      for (var i = 0; i < arrayrecchq.length; i++) {
        if (arrayrecchq[i].Chequeno) {
          NewCol[j] = arrayrecchq[i];
          NewCol[j].C0 = j + 1;
          j++;
        }
      }
      for (var i = j; i < arrayrecchq.length; i++) {
        NewCol[j] = { C0: j + 1 };
        j++;
      }
      this.setState({ recchq: NewCol });
      setTimeout(() => {
        console.log(this.state.recchq);
        this.setState({ recchq: this.state.recchq });
        this.Calculate();
      }, 500);
    } else {
      AlertPopup("Warning", "คุณยังไม่ได้เลือกข้อมูล");
    }
  };
  DelCredit = () => {
    var arrayCredit = this.state.Credit;
    var id = this.state.id1;
    if (this.Creditno.current.value !== "" && id !== undefined) {
      this.Creditno.current.value = "";
      this.setState({ Chargepay: "" });
      this.setState({ Credittype: "" });
      this.Creditpay.current.value = (0).toFixed(2);
      this.Charge.current.value = (0).toFixed(2);
      this.Chargeamount.current.value = (0).toFixed(2);
      this.Creditamount.current.value = (0).toFixed(2);
      this.Confirmno.current.value = "";
      this.CreditRemark.current.value = "";

      arrayCredit[id].C0 = "";
      arrayCredit[id].Creditno = "";
      arrayCredit[id].Creditamount = "";
      arrayCredit[id].Credittype = "";
      arrayCredit[id].Creditpay = "";
      arrayCredit[id].Charge = "";
      arrayCredit[id].Chargeamount = "";
      arrayCredit[id].Chargepay = "";
      arrayCredit[id].Confirmno = "";
      arrayCredit[id].Remark = "";

      var NewCol = [];
      var j = 0;
      for (var i = 0; i < arrayCredit.length; i++) {
        if (arrayCredit[i].Creditno) {
          NewCol[j] = arrayCredit[i];
          NewCol[j].C0 = j + 1;
          j++;
        }
      }
      for (var i = j; i < arrayCredit.length; i++) {
        NewCol[j] = { C0: j + 1 };
        j++;
      }
      this.setState({ Credit: NewCol });
      setTimeout(() => {
        console.log(this.state.Credit);
        this.setState({ Credit: this.state.Credit });
        this.Calculate();
      }, 500);
    } else {
      AlertPopup("Warning", "คุณยังไม่ได้เลือกข้อมูล");
    }
  };
  Okrecchq = () => {
    if (this.Chequeno.current.value === "") {
      AlertPopup("Warning", "เลขที่เช็ค/ตั่วเงิน");
      return;
    } else if (this.state.s_Bankname === "") {
      AlertPopup("Warning", "ธนาคาร");
      return;
    } else if (this.state.s_Bankbranch === "") {
      AlertPopup("Warning", "สาขาธนาคาร");
      return;
    } else if (this.state.Chqdate === "") {
      AlertPopup("Warning", "เช็คลงวันที่");
      return;
    } else if (this.Chqamount.current.value === "") {
      AlertPopup("Warning", "มูลค่าเซ็ค/ตั่วเงิน");
      return;
    } else if (this.Chqpay.current.value === "") {
      AlertPopup("Warning", "ยอดชำระหนี้");
      return;
    }
    let arrayrecchq = this.state.recchq;
    var j = 0;
    for (let i = this.state.recchq.length - 1; i >= 0; i--) {
      // หาจากล่างขึ้นบน

      console.log(
        "i",
        i,
        "Chequeno",
        this.state.recchq[i].Chequeno,
        "this.Chequeno.current.value",
        this.Chequeno.current.value
      );
      if (this.state.recchq[i].Chequeno === this.Chequeno.current.value) {
        j = i;
        break;
      } else if (!this.state.recchq[i].Chequeno) {
        j = i;
      }
    }
    arrayrecchq[j] = {
      C0: j + 1,
      Chequeno: this.Chequeno.current.value,
      Chqpay: this.Chqpay.current.value,
      Bankcode: this.state.s_Bankcode,
      Bankbranch: this.state.s_Bankbranch,
      Chqdate: this.state.Chqdate,
      Chqamount: this.Chqamount.current.value,
      Bankname: this.state.s_Bankname,
      Remark: this.ChqRemark.current.value,
    };
    this.setState({ recchq: arrayrecchq });
    this.Chequeno.current.value = "";
    this.setState({ s_Bankname: "" });
    this.setState({ s_Bankcode: "" });
    this.setState({ s_Bankbranch: "" });
    // this.state.Chqdate = this.CustomerNamedate.current.value
    this.setState({ s_Chqdate: "" });
    this.Chqamount.current.value = "";
    this.Chqpay.current.value = "";
    this.ChqRemark.current.value = "";
    this.Calculate();
  };
  OkCredit = () => {
    if (this.Creditno.current.value === "") {
      AlertPopup("Warning", "เลขบัตร");
      return;
    } else if (this.state.Chargepay === "") {
      AlertPopup("Warning", "คำนวณค่าชาร์จ");
      return;
    } else if (this.state.Credittype === "") {
      AlertPopup("Warning", "ประเภทบัตร");
      return;
    } else if (this.Creditpay.current.value === "") {
      AlertPopup("Warning", "ยอดรับชำระ");
      return;
    } else if (this.Creditamount.current.value === "") {
      AlertPopup("Warning", "รวมยอดบัตร");
      return;
    }
    var arrayCredit = this.state.Credit;
    var j = 0;
    for (var i = this.state.Credit.length - 1; i >= 0; i--) {
      // หาจากล่างขึ้นบน
      if (this.state.Credit[i].Creditno === this.Creditno.current.value) {
        j = i;
        break;
      } else if (!this.state.Credit[i].Creditno) {
        j = i;
      }
    }
    arrayCredit[j] = {
      C0: j + 1,
      Creditno: this.Creditno.current.value,
      Creditamount: this.Creditamount.current.value,
      Credittype: this.state.Credittype,
      Creditpay: this.Creditpay.current.value,
      Charge: this.Charge.current.value,
      Chargeamount: this.Chargeamount.current.value,
      Chargepay: this.state.Chargepay,
      Confirmno: this.Confirmno.current.value,
      Remark: this.CreditRemark.current.value,
    };
    this.setState({ Credit: arrayCredit });
    this.Creditno.current.value = "";
    this.setState({ Chargepay: "" });
    this.setState({ Credittype: "" });
    this.Creditpay.current.value = (0).toFixed(2);
    this.Charge.current.value = (0).toFixed(2);
    this.Chargeamount.current.value = (0).toFixed(2);
    this.Creditamount.current.value = (0).toFixed(2);
    this.Confirmno.current.value = "";
    this.CreditRemark.current.value = "";
    this.Calculate();
  };
  onRowClickrecchq = (row, col, id) => {
    this.setState({ id: id });
    if (row.Chequeno) {
      this.Chequeno.current.value = row.Chequeno;
      this.setState({ s_Bankname: row.Bankname });
      this.setState({ s_Bankcode: row.Bankcode });
      this.setState({ s_Bankbranch: row.Bankbranch });
      this.setState({ s_Chqdate: row.Chqdate });
      this.Chqamount.current.value = row.Chqamount;
      this.Chqpay.current.value = row.Chqpay;
      this.ChqRemark.current.value = row.Remark;
    }
  };
  onRowClickCredit = (row, col, id) => {
    this.setState({ id1: id });
    if (row.Creditno !== "" && row.Creditno !== undefined) {
      this.Creditno.current.value = row.Creditno;
      this.setState({ Chargepay: row.Chargepay });
      this.setState({ Credittype: row.Credittype });
      this.Creditpay.current.value = row.Creditpay;
      this.Charge.current.value = row.Charge;
      this.Chargeamount.current.value = row.Chargeamount;
      this.Creditamount.current.value = row.Creditamount;
      this.Confirmno.current.value = row.Confirmno;
      this.CreditRemark.current.value = row.Remark;
    }
  };
  onBlur = (e) => {
    if (e.target.value && e.target.type === "number") {
      e.target.value = parseFloat(e.target.value).toFixed(2);
      if (e.target.name === "Chqpay") {
        this.Chqamount.current.value = parseFloat(
          this.Chqpay.current.value
        ).toFixed(2);
        this.Chqpay.current.value = parseFloat(
          this.Chqpay.current.value
        ).toFixed(2);
      }
    }
  };
  onBlurCredit = async () => {
    await this.calCharge();
    await this.calCredit();
  };
  Blurcharge = async (e) => {
    // console.log(e.target.id);

    await this.calCharge(e);
    await this.calCredit();
  };
  Keycharge = async (e) => {
    if (e.key === "Enter") {
      // this.Charge.current.value = parseFloat(this.Charge.current.value).toFixed(2)
      // this.Chargeamount.current.value = parseFloat(this.Creditpay.current.value / 100 * this.Charge.current.value).toFixed(2)
      await this.calCharge(e);
      await this.calCredit();
    }
  };
  calCharge = (e) => {
    // คำนวณยอด Charge
    console.log("calCharge", e);
    if (typeof e !== "undefined") {
      console.log("calCharge e.target.id ", e.target.id);
      if (e.target.id === "Chargeamount") {
        this.Charge.current.value = parseFloat(
          (this.Chargeamount.current.value * 100) / this.Creditpay.current.value
        ).toFixed(2);
      }
      if (e.target.id === "Charge") {
        //   this.Charge.current.value = parseFloat((this.Charge.current.value)).toFixed(2)
        this.Chargeamount.current.value = parseFloat(
          (this.Creditpay.current.value / 100) * this.Charge.current.value
        ).toFixed(2);
      }
    } else {
      this.Chargeamount.current.value = parseFloat(
        (this.Creditpay.current.value / 100) * this.Charge.current.value
      ).toFixed(2);
    }
  };

  onKey = (e) => {
    if (e.target.name === "Chqamount" && e.key === "Enter") {
      this.Chqamount.current.value = parseFloat(
        this.Chqamount.current.value
      ).toFixed(2);
      this.Chqpay.current.value = parseFloat(
        this.Chqamount.current.value
      ).toFixed(2);
    }
    if (e.target.name === "Creditpay" && e.key === "Enter") {
      this.Creditpay.current.value = parseFloat(
        this.Creditpay.current.value
      ).toFixed(2);
      this.Creditamount.current.value = parseFloat(
        this.Creditpay.current.value
      ).toFixed(2);
    }
  };
  onClick = (e) => {
    if (e.target.value && e.target.type === "number") {
      e.target.value = Number(e.target.value);
      e.target.select();
    }
  };
  /*-------------------------------------------------------------------------------------------------------------------------------------*/

  render() {
    return (
      <div
        className="popup"
        onClick={(e) => this.onClick(e)}
        onBlur={this.onBlur}
      >
        <br></br>
        <br></br>
        {this.state.PopupFind ? (
          <Find
            closePopup={this.Switch_PopupFind}
            Customer={this.props.Customer}
          />
        ) : null}
        <div className="popup_inner">
          <div className="PopUpOtherDivH" align="left"></div>
          <div className="DivPopupLeft" align="left">
            <div className="col-xs-4 col-sm-4 col-lg-4 col-md-4">
              <div className=""> ยอดรวมเงินที่ต้องชำระ : </div>
              <input
                type="text"
                className="SaveMoneyInput Green Price "
                disabled
                ref={this.AmountPayable}
              />
            </div>
            <div className="col-xs-4 col-sm-4 col-lg-4 col-md-4">
              <div className=""> ยอดคงเหลือ : </div>
              <input
                type="text"
                className="SaveMoneyInput Red Price"
                disabled
                ref={this.Balance}
              />
            </div>
            <div className="col-xs-4 col-sm-4 col-lg-4 col-md-4">
              <div className=""> - </div>
              <input
                type="button"
                className="SaveMoneyInput"
                value="ตกลง"
                onClick={() => this.OnSave("accress")}
                disabled={this.state.submitbuttondisabled}
              />
            </div>
          </div>
          <div
            className="DivPopupLeft col-xs-12 col-sm-12 col-lg-12 col-md-12"
            align="left"
          >
            <br />
            <Nav
              bsStyle="tabs"
              activeKey={this.state.activeKey}
              className="Inventory"
              onSelect={(k) => {
                this.setState({ activeKey: k });
              }}
            >
              {this.state.PCash === "1" ? (
                <NavItem eventKey="0"> เงินสด/เงินโอน </NavItem>
              ) : null}
              {this.state.Pcheck === "1" ? (
                <NavItem eventKey="1"> เช็ครับ/ตั๋วเงิน </NavItem>
              ) : null}
              {this.state.PCCredit === "1" ? (
                <NavItem eventKey="2"> บัตรเครดิต </NavItem>
              ) : null}
              {this.state.PIncome === "1" ? (
                <NavItem eventKey="3"> รายได้อื่นๆ </NavItem>
              ) : null}
              {this.state.PExpens === "1" ? (
                <NavItem eventKey="4"> ค่าใช้จ่ายอื่นๆ </NavItem>
              ) : null}
            </Nav>
            <div
              className="SaveMoneySubDiv"
              hidden={this.state.activeKey === "0" ? false : true}
            >
              <div className="row">
                <div className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8 ">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 ">
                    <span className="input-group-addon"> ยอดเงินสดรับ : </span>
                    <input
                      type="number"
                      className="form-control Price SaveMoneyInput"
                      min="0.00"
                      ref={this.CashReceipt1}
                      onKeyUp={this.CashReceipt.bind(null)}
                    />
                    <span className="input-group-addon icon">
                      <i className="fas fa-calculator"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8 SaveMoneyGroupInput"
                style={{ marginTop: "25px" }}
              >
                <div className="title"> รับเงินโอนเข้าบัญชี </div>
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <SelectDatas
                    origin="BOOKNO" // เลขที่บัญชี
                    valueSelect={(e) => this.SelectSetData("BOOKNO", e)} // รับค่ากลับ
                    title="เลขที่บัญชี : "
                    defaultselect={this.state.Bookno} // ค่าเริ่มต้นของ เลขที่บัญชี
                    popup={true}
                  />
                </div>
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon SaveMoneyAddon">
                    {" "}
                    ยอดเงินโอน :{" "}
                  </span>
                  <input
                    type="number"
                    className="form-control "
                    ref={this.Bankamount}
                    onKeyUp={this.CashReceipt.bind(null)}
                  />
                  <span className="input-group-addon icon">
                    <i className="fas fa-calculator"></i>
                  </span>
                </div>
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon SaveMoneyAddon">
                    {" "}
                    ค่าธรรมเนียมจ่ายหักบัญชี :{" "}
                  </span>
                  <input
                    type="number"
                    className="form-control"
                    ref={this.Bankexpend}
                    onKeyUp={this.CashReceipt.bind(null)}
                  />
                  <span className="input-group-addon icon">
                    <i className="fas fa-calculator"></i>
                  </span>
                </div>
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon SaveMoneyAddon">
                    {" "}
                    หมายเหตุการโอน :{" "}
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    ref={this.Remark}
                  />
                </div>
              </div>
            </div>
            <div
              className="SaveMoneySubDiv"
              hidden={this.state.activeKey === "1" ? false : true}
            >
              <div className="SubDiv1">
                <BootstrapTable
                  height="300"
                  options={{
                    noDataText: "...",
                    onRowClick: this.onRowClickrecchq,
                  }}
                  data={this.state.recchq}
                  hover={true}
                >
                  <TableHeaderColumn
                    dataField="C0"
                    isKey
                    width="35"
                    dataAlign="center"
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Chequeno"
                    editable={this.state.C1_editable}
                    dataAlign="left"
                    width="130"
                  >
                    {" "}
                    <div align="center"> เลขที่เซ็ค/ตั่วเงิน </div>{" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Chqpay"
                    editable={false}
                    dataAlign="left"
                    width="100"
                  >
                    {" "}
                    <div align="center"> ยอดชำระ </div>{" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="Bankcode"
                    hidden
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="Bankbranch"
                    hidden
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="Chqdate"
                    hidden
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="Chqamount"
                    hidden
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="Bankname"
                    hidden
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="Remark"
                    hidden
                  ></TableHeaderColumn>
                </BootstrapTable>
              </div>
              <div className="SubDiv2">
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 SaveMoneyGroupInput">
                  <div className="title"> รายละเอียด </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      เลขที่เช็ค/ตั่วเงิน :{" "}
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.Chequeno}
                    />
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <SelectDatas
                      origin="Csbank" // ธนาคาร
                      valueSelect={(e, e1) =>
                        this.SelectSetData("Csbank", e, e1)
                      } // รับค่ากลับ
                      title="ธนาคาร :"
                      defaultselect={this.state.s_Bankcode} // ค่าเริ่มต้นของ ธนาคาร
                      popup={true}
                    />
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <SelectDatas
                      origin="Bankbranch" // สาขาธนาคาร
                      valueSelect={(e, e1) =>
                        this.SelectSetData("Bankbranch", e, e1)
                      } // รับค่ากลับ
                      title="สาขาธนาคาร :"
                      defaultselect={this.state.s_Bankbranch} // ค่าเริ่มต้นของ สาขาธนาคาร
                      popup={true}
                    />
                  </div>
                  <MaterialUIPickers
                    title="วันที่ขาย :"
                    style={mystyle}
                    DateValue={(e) => this.SelectSetData("Calendar", e)}
                    defaultdate={this.state.Chqdate}
                    popup={true}
                  />
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      มูลค่าเช็ค/ตั่วเงิน :{" "}
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      ref={this.Chqamount}
                      name="Chqamount"
                      onKeyDown={this.onKey}
                    />
                    <span className="input-group-addon icon">
                      <i className="fas fa-calculator"></i>
                    </span>
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      ยอดชำระหนี้ :{" "}
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      ref={this.Chqpay}
                    />
                    <span className="input-group-addon icon">
                      <i className="fas fa-calculator"></i>
                    </span>
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      หมายเหตุ :{" "}
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.ChqRemark}
                    />
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <button
                      className="SaveMoneySubBTN"
                      onClick={this.Newrecchq}
                    >
                      <i className="far fa-file-alt"> New </i>
                    </button>
                    <button
                      className="SaveMoneySubBTN"
                      onClick={this.Delrecchq}
                    >
                      <i className="fas fa-trash-alt"> Del </i>
                    </button>
                    <button
                      className="SaveMoneySubBTN"
                      onClick={() => {
                        this.setState({ PopupFind: !this.state.PopupFind });
                      }}
                    >
                      <i className="fas fa-search"> Find </i>
                    </button>
                    <button className="SaveMoneySubBTN" onClick={this.Okrecchq}>
                      <i className="fas fa-check"> OK </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="SaveMoneySubDiv"
              hidden={this.state.activeKey === "2" ? false : true}
            >
              <div className="SubDiv1">
                <BootstrapTable
                  height="300"
                  options={{
                    noDataText: "...",
                    onRowClick: this.onRowClickCredit,
                  }}
                  data={this.state.Credit}
                  hover={true}
                >
                  <TableHeaderColumn
                    dataField="C0"
                    isKey
                    width="35"
                    dataAlign="center"
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Creditno"
                    editable={this.state.C1_editable}
                    dataAlign="left"
                    width="50%"
                  >
                    {" "}
                    <div align="center"> เลขที่เซ็ค/ตั่วเงิน </div>{" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Creditpay"
                    editable={false}
                    dataAlign="left"
                    width="100"
                  >
                    {" "}
                    <div align="center"> ยอดชำระ 1 </div>{" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Credittype"
                    width="50 "
                  ></TableHeaderColumn>
                  <TableHeaderColumn dataField="Charge" width="50 ">
                    Charge
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="Creditamount" width="50%">
                    <div align="center"> จำนวนเงิน </div>
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="Chargeamount" width="50 ">
                    Chargeamount
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="Chargepay" width="50 ">
                    Chargepay
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="Confirmno" width="50 ">
                    Confirmno
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="Remark" width="50 ">
                    Remark
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
              <div className="SubDiv2">
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 SaveMoneyGroupInput">
                  <div className="title"> รายละเอียด </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      เลขบัตร :{" "}
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.Creditno}
                    />
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <SelectDatas
                      origin="Fee" // คำนวณค่าชาร์จ
                      valueSelect={(e, e1) => this.SelectSetData("Fee", e, e1)} // รับค่ากลับ
                      title="คำนวณค่าชาร์จ :"
                      defaultselect={this.state.Chargepay} // ค่าเริ่มต้นของ คำนวณค่าชาร์จ
                      popup={true}
                    />
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <SelectDatas
                      origin="Credittype" // ประเภทบัตร
                      valueSelect={(e, e1) =>
                        this.SelectSetData("Credittype", e, e1)
                      } // รับค่ากลับ
                      title="ประเภทบัตร :"
                      defaultselect={this.state.Credittype} // ค่าเริ่มต้นของ ประเภทบัตร
                      popup={true}
                    />
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      ยอดรับชำระ :{" "}
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      ref={this.Creditpay}
                      name="Creditpay"
                      onBlur={this.onBlurCredit}
                      onKeyDown={this.onKey}
                    />
                    <span className="input-group-addon icon">
                      <i className="fas fa-calculator"></i>
                    </span>
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      %ชาร์จ:{" "}
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      disabled={this.state.charge}
                      id={"Charge"}
                      ref={this.Charge}
                      onBlur={(e) => this.Blurcharge(e)}
                      onKeyDown={(e) => this.Keycharge(e)}
                    />
                    <span className="input-group-addon icon">
                      <i className="fas fa-calculator"></i>
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      disabled={this.state.charge}
                      id={"Chargeamount"}
                      ref={this.Chargeamount}
                      onBlur={(e) => this.Blurcharge(e)}
                      onKeyDown={(e) => this.Keycharge(e)}
                    />
                    <span className="input-group-addon icon">
                      <i className="fas fa-calculator"></i>
                    </span>
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      รวมยอดบัตร :{" "}
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      ref={this.Creditamount}
                    />
                    <span className="input-group-addon icon">
                      <i className="fas fa-calculator"></i>
                    </span>
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      เลขที่อนุมัติ :{" "}
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.Confirmno}
                    />
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon SaveMoneyAddon">
                      {" "}
                      หมายเหตุ :{" "}
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.CreditRemark}
                    />
                  </div>
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <button
                      className="SaveMoneySubBTN"
                      onClick={this.NewCredit}
                    >
                      <i className="far fa-file-alt"> New </i>
                    </button>
                    <button
                      className="SaveMoneySubBTN"
                      onClick={this.DelCredit}
                    >
                      <i className="fas fa-trash-alt"> Del </i>
                    </button>
                    {/* <button className="SaveMoneySubBTN"><i className="fas fa-search"> Find </i></button> */}
                    <button className="SaveMoneySubBTN" onClick={this.OkCredit}>
                      <i className="fas fa-check"> OK </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="SaveMoneySubDiv"
              hidden={this.state.activeKey === "3" ? false : true}
            >
              <BootstrapTable
                data={this.state.Otherincome}
                trClassName="trClassName"
                tableHeaderClass="trClassName"
                options={{
                  noDataText: "...",
                  // onRowClick: this.onRowClick,
                }}
                cellEdit={{
                  //แก้ไข
                  mode: "click",
                  blurToSave: true,
                  // beforeSaveCell: this.onBeforeSaveCell,
                  afterSaveCell: this.onAfterSaveCellOtherincomecal,
                }}
                keyBoardNav={{ enterToEdit: true }}
              >
                <TableHeaderColumn
                  dataField="C0"
                  isKey
                  width="35"
                  dataAlign="center"
                ></TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Incomecode"
                  editable={false}
                  dataAlign="left"
                  width="150"
                >
                  {" "}
                  <div align="center"> รหัสรายได้ </div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="BTN"
                  editable={false}
                  dataAlign="left"
                  width="35"
                  dataFormat={this.OtherincomeBTN.bind(this)}
                >
                  <div align="center"></div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Incomename"
                  editable={false}
                  dataAlign="left"
                  width="150"
                >
                  {" "}
                  <div align="center"> ชื่อรายได้ </div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Incomeremark"
                  editable={true}
                  dataAlign="left"
                  width="200"
                >
                  {" "}
                  <div align="center"> หมายเหตุ </div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Incomeamount"
                  editable={true}
                  dataAlign="left"
                  width="100"
                >
                  {" "}
                  <div align="center"> จำนวนเงิน </div>{" "}
                </TableHeaderColumn>
              </BootstrapTable>
              <div className="row">
                <div className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8 FromGroupPOPUP"></div>
                <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4 FromGroupPOPUP">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">รายได้รวมอื่นๆ : </span>
                    <input
                      type="text"
                      className="form-control Price"
                      ref={this.sumOtherincome}
                    />
                    <span
                      className="input-group-addon icon"
                      onClick={() => this.Calculate()}
                    >
                      <i className="fas fa-calculator"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="SaveMoneySubDiv"
              hidden={this.state.activeKey === "4" ? false : true}
            >
              <BootstrapTable
                data={this.state.expenses}
                trClassName="trClassName"
                tableHeaderClass="trClassName"
                options={{
                  noDataText: "...",
                  onRowClick: this.onRowClick,
                }}
                cellEdit={{
                  //แก้ไข
                  mode: "click",
                  blurToSave: true,
                  beforeSaveCell: this.onBeforeSaveCell,
                  afterSaveCell: this.onAfterSaveCellAC4cal,
                }}
                keyBoardNav={{ enterToEdit: true }}
              >
                <TableHeaderColumn
                  dataField="C0"
                  isKey
                  width="35"
                  dataAlign="center"
                ></TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Expensescode"
                  editable={false}
                  dataAlign="left"
                  width="150"
                >
                  {" "}
                  <div align="center"> รหัสค่าใช้จ่าย </div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="BTN"
                  editable={false}
                  dataAlign="left"
                  width="35"
                  dataFormat={this.expensesBTN.bind(this)}
                >
                  <div align="center"></div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Expensesname"
                  editable={false}
                  dataAlign="left"
                  width="150"
                >
                  {" "}
                  <div align="center"> ชื่อค่าใช้จ่าย </div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Expensesremark"
                  editable={true}
                  dataAlign="left"
                  width="200"
                >
                  {" "}
                  <div align="center"> หมายเหตุ </div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Expensesamount"
                  editable={true}
                  dataAlign="left"
                  width="100"
                >
                  {" "}
                  <div align="center"> จำนวนเงิน </div>{" "}
                </TableHeaderColumn>
              </BootstrapTable>
              <div className="row">
                <div className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8 FromGroupPOPUP"></div>
                <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4 FromGroupPOPUP">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">รายได้รวมอื่นๆ : </span>
                    <input
                      type="text"
                      className="form-control Price"
                      ref={this.sumExpenses}
                    />
                    <span
                      className="input-group-addon icon"
                      onClick={() => this.Calculate()}
                    >
                      <i className="fas fa-calculator"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.PopupOtherBat ? (
          <OtherBat closePopup={this.Switch_PopupOtherBat} />
        ) : null}
        {this.state.PopupExpenses ? (
          <Expenses closePopup={this.Switch_PopupExpenses} />
        ) : null}
      </div>
    );
  }
  Switch_PopupFind = (data, type) => {
    this.setState({ PopupFind: !this.state.PopupFind });
  };
  Switch_PopupOtherBat = (data, type) => {
    this.setState({ PopupOtherBat: !this.state.PopupOtherBat });
    if (type === "Y") {
      var DATASP = data.split("|");
      var row = this.state.Otherincome;
      var j = 0;
      for (var i = row.length - 1; i >= 0; i--) {
        if (!row[i].Incomecode) {
          j = i;
        }
      }
      row[j] = {
        C0: j + 1,
        Incomecode: DATASP[0],
        Incomename: DATASP[1],
        BTN: "delect",
      };
      this.setState({ Otherincome: row });
    }
  };
  Switch_PopupExpenses = (data, type) => {
    this.setState({ PopupExpenses: !this.state.PopupExpenses });
    if (type === "Y") {
      var DATASP = data.split("|");
      var row = this.state.expenses;
      var j = 0;
      for (var i = row.length - 1; i >= 0; i--) {
        if (!row[i].Expensescode) {
          j = i;
        }
      }
      row[j] = {
        C0: j + 1,
        Expensescode: DATASP[0],
        Expensesname: DATASP[1],
        BTN: "delect",
      };
      this.setState({ expenses: row });
    }
  };
}

export class OtherBat extends React.Component {
  constructor(props) {
    super(props);
    this.search = createRef();
    this.state = {
      MenuItem: [],
      selected: "0",
    };
  }
  onSelectRow = (data) => {
    this.props.closePopup(data.C1 + "|" + data.C2, "Y");
  };
  componentDidMount() {
    var url = "CSINCOME/GETALLCSINCOME?";
    var data_ = this.state.MenuItem;
    console.log(genURL(url));
    axios.get(genURL(url), { timeout: 60000 }).then((res) => {
      for (var i = 0; i < res.data.length; i++) {
        data_[i] = {
          C0: i + 1,
          C1: res.data[i].CODE,
          C2: res.data[i].MYNAMETH,
        };
        if (i === res.data.length - 1) {
          this.setState({ MenuItem: data_ });
        }
      }
    });
  }
  loadData = async (datasearch) => {
    let url = "";
    if (this.state.selected === "0") {
      url = "CSINCOME/GETCODESCSINCOME?Codes=" + datasearch;
    } else if (this.state.selected === "1") {
      url = "CSINCOME/GETNAMECSINCOME?Name=" + datasearch;
    }
    var data_ = [];
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 60000 })
      .then((res) => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            data_[i] = {
              C0: i + 1,
              C1: res.data[i].CODE,
              C2: res.data[i].MYNAMETH,
            };
          }
        }
      })
      .then((_) => {
        this.setState({ MenuItem: [...data_] });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  searchkeyDown = (e) => {
    if (e.target.name === "search" && e.key === "Enter") {
      this.loadData(this.search.current.value);
    }
  };
  render() {
    return (
      <div
        className="popup"
        // onKeyPress={this.onKeyPress}
      >
        <div className="popup_inner">
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-at"> OtherBat </i>
            </div>
            <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          <div className="panel-body divTable" align="left">
            <div>
              <div className="form-inline">
                <div className="form-group mb-2">
                  <input
                    type="radio"
                    id="Choice-1"
                    name="myRadio"
                    value="0"
                    checked={this.state.selected === "0"}
                    onChange={(e) =>
                      this.setState({ selected: e.target.value })
                    }
                  />
                  <span className="choiceSty">
                    &nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;
                  </span>
                  <input
                    type="radio"
                    id="Choice-2"
                    name="myRadio"
                    value="1"
                    checked={this.state.selected === "1"}
                    onChange={(e) =>
                      this.setState({ selected: e.target.value })
                    }
                  />
                  <span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;</span>
                </div>
              </div>
            </div>
            <div className="input-group width-grop">
              <input
                type="text"
                className="form-control"
                placeholder="กรอกคำค้นหา"
                ref={this.search}
                name="search"
                onKeyDown={(e) => this.searchkeyDown(e)}
              />
              <span className="input-group-addon txt-img icon">
                <i
                  className="fas fa-search"
                  onClick={() => {
                    this.loadData(this.search.current.value);
                  }}
                ></i>
              </span>
              <span className="input-group-addon txt-img icon">
                {" "}
                <i
                  className="fas fa-sync-alt"
                  onClick={() => {
                    this.componentDidMount();
                  }}
                ></i>
              </span>
            </div>
            <BootstrapTable
              data={this.state.MenuItem}
              options={{
                onRowClick: this.onSelectRow,
                noDataText: this.state.loadding,
              }}
              hover
              condensed
            >
              <TableHeaderColumn
                dataField="C0"
                className="columnNumber"
                isKey
                width="35"
                dataAlign="center"
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="C1"
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="left"
                width="100"
              >
                <div align="center"> รหัส </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="C2"
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="left"
                width="200"
              >
                <div align="center"> รายการ </div>
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      </div>
    );
  }
}
export class Find extends React.Component {
  constructor(props) {
    super(props);
    this.search = createRef();
    this.state = {
      MenuItem: [],
    };
  }
  onSelectRow = (data) => {
    this.props.closePopup(data.C1 + "|" + data.C2, "Y");
  };
  componentDidMount() {
    var url = "CSCHEQUEIN/GETCUSTOMER?Code=" + this.props.Customer;
    var data_ = this.state.MenuItem;
    console.log(genURL(url));
    axios
      .get(genURL(url), { timeout: 60000 })
      .then((res) => {
        for (var i = 0; i < res.data.length; i++) {
          data_[i] = {
            C0: i + 1,
            C1: res.data[i].CHEQUENO,
            C2: res.data[i].BANKNAME,
          };
          if (i === res.data.length - 1) {
            this.setState({ MenuItem: data_ });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    return (
      <div className="popup" onKeyPress={this.onKeyPress}>
        <div className="popup_inner">
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-at"> ค้นหาเช็ค </i>
            </div>
            <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          <div className="panel-body divTable" align="left">
            <BootstrapTable
              data={this.state.MenuItem}
              options={{
                onRowClick: this.onSelectRow,
                noDataText: "ไม่พบข้อมูล",
              }}
              hover
              condensed
            >
              <TableHeaderColumn
                dataField="C0"
                className="columnNumber"
                isKey
                width="35"
                dataAlign="center"
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="C1"
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="left"
                width="100"
              >
                <div align="center"> รหัส </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="C2"
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="left"
                width="200"
              >
                <div align="center"> รายการ </div>
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      </div>
    );
  }
}
export class Expenses extends React.Component {
  constructor(props) {
    super(props);
    this.search = createRef();
    this.state = {
      MenuItem2: [],
      selected: "0",
    };
  }
  onSelectRow = (data) => {
    this.props.closePopup(data.C1 + "|" + data.C2, "Y");
  };
  componentDidMount() {
    var url = "CSEXPENSE/GETALL?";
    var data_ = this.state.MenuItem2;
    console.log(genURL(url));
    axios.get(genURL(url), { timeout: 60000 }).then((res) => {
      if (res.data === undefined) {
        return;
      }
      for (var i = 0; i < res.data.length; i++) {
        data_[i] = {
          C0: i + 1,
          C1: res.data[i].CODE,
          C2: res.data[i].MYNAMETH,
        };
        if (i === res.data.length - 1) {
          this.setState({ MenuItem2: data_ });
        }
      }
    });
  }
  loadData = async (datasearch) => {
    let url = "";
    if (this.state.selected === "0") {
      url = "CSEXPENSE/GETCODES?Codes=" + datasearch;
    } else if (this.state.selected === "1") {
      url = "CSEXPENSE/GETNAME?Name=" + datasearch;
    }
    var data_ = [];
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 60000 })
      .then((res) => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            data_[i] = {
              C0: i + 1,
              C1: res.data[i].CODE,
              C2: res.data[i].MYNAMETH,
            };
          }
        }
      })
      .then((_) => {
        this.setState({ MenuItem2: [...data_] });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  onKeyPress = (e) => {
    if (e.target.name === "search" && e.key === "Enter") {
      this.loadData(this.search.current.value);
    }
  };
  render() {
    return (
      <div className="popup" onKeyPress={this.onKeyPress}>
        <div className="popup_inner">
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-at"> Expenses </i>
            </div>
            <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          <div className="panel-body divTable" align="left">
            <div>
              <div className="form-inline">
                <div className="form-group mb-2">
                  <input
                    type="radio"
                    id="Choice-1"
                    name="myRadio"
                    value="0"
                    checked={this.state.selected === "0"}
                    onChange={(e) =>
                      this.setState({ selected: e.target.value })
                    }
                  />
                  <span className="choiceSty">
                    &nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;
                  </span>
                  <input
                    type="radio"
                    id="Choice-2"
                    name="myRadio"
                    value="1"
                    checked={this.state.selected === "1"}
                    onChange={(e) =>
                      this.setState({ selected: e.target.value })
                    }
                  />
                  <span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;</span>
                </div>
              </div>
            </div>
            <div className="input-group width-grop">
              <input
                type="text"
                className="form-control"
                placeholder="กรอกคำค้นหา"
                ref={this.search}
                name="search"
              />
              <span className="input-group-addon txt-img icon">
                <i
                  className="fas fa-search"
                  onClick={() => {
                    this.loadData(this.search.current.value);
                  }}
                ></i>
              </span>
              <span className="input-group-addon txt-img icon">
                {" "}
                <i
                  className="fas fa-sync-alt"
                  onClick={() => {
                    this.componentDidMount();
                  }}
                ></i>
              </span>
            </div>
            <BootstrapTable
              data={this.state.MenuItem2}
              options={{
                onRowClick: this.onSelectRow,
                noDataText: this.state.loadding,
              }}
              hover
              condensed
              height="600"
            >
              <TableHeaderColumn
                dataField="C0"
                isKey
                width="35"
                className="columnNumber"
                dataAlign="center"
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="C1"
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="left"
                width="100"
              >
                <div align="center"> รหัส </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="C2"
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="left"
                width="200"
              >
                <div align="center"> รายการ </div>
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>

        <Snackbar
          place="br"
          color={this.state.color}
          icon={this.state.icon}
          autoClose={3600}
          message={this.state.messagealert}
          open={this.state.opensnackbar}
          closeNotification={() => {
            this.setState({ opensnackbar: false });
          }}
          close
        />
      </div>
    );
  }
}
